import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import BoltIcon from '@flipster/react/icon/generated/BoltIcon';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { flex, hstack } from '@flipster/styled-system/patterns';

import useStakeFlow from '../useStakeFlow';
import { sparkLaunchpoolItemBunja } from './bunja';

const SparkLaunchpoolItemHeader = () => {
  const t = useTranslations();
  const { isClosedAtom, isStakableAtom } = useBunja(sparkLaunchpoolItemBunja);
  const isClosed = useAtomValue(isClosedAtom);
  const isStakable = useAtomValue(isStakableAtom);
  const joinSparkLaunchpool = useStakeFlow();
  return (
    <div className={hstack({ justify: 'space-between', mb: 12, color: 'content.default.level-5' })}>
      <TitleArea />
      {!isClosed && (
        <Button
          hierarchy='primary'
          color='accent'
          size='medium'
          label={t('Autogen_common.r251126.s_Join')}
          disabled={!isStakable}
          onClick={joinSparkLaunchpool}
          css={css.raw({ w: 78 })}
        />
      )}
    </div>
  );
};

export default SparkLaunchpoolItemHeader;

const TitleArea = () => {
  return (
    <div
      className={css({
        display: 'grid',
        gap: 12,
        gridTemplateColumns: 'max-content minmax(0, max-content)',
        alignItems: 'center',
      })}
    >
      <BoltIcon size={32} />
      <div>
        <Link href='/spark/reward'>
          <div className={flex({ gap: 4, textStyle: 'Title/XS', color: 'inverse.white' })}>
            Flipster Sparks
            <ChevronRightIcon size={20} className={css({ color: 'content.default.level-2' })} />
          </div>
        </Link>
        <span className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-5' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Redeem_a_share_of_the_launchpool' />
        </span>
      </div>
    </div>
  );
};
